import { render, staticRenderFns } from "./DigitalDistribution.vue?vue&type=template&id=7e9a16e8&scoped=true"
import script from "./DigitalDistribution.vue?vue&type=script&lang=js"
export * from "./DigitalDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9a16e8",
  null
  
)

export default component.exports